import React, { useEffect, useState } from 'react'
import styles from './dropdown-input.module.scss'
import Select, { components } from 'react-select'

interface IOption {
  label: string,
  value: string | number
}

interface IProps {
  label?: string
  modifiers?: string
  name: string
  curried?: boolean
  readOnly?: boolean
  defaultDropDownValue?: string | number
  defaultInputValue?: string
  handleInputChange: any
  clearInputValue?: boolean
  handleDropDownChange: any
  placeholder?: string,
  options: Array<IOption>
  selected?: string
}

const DropDownInput = React.memo(function DropDownInput(props: IProps) {
  const [inputValue, setInputValue] = useState('1')
  const [focused, setFocused] = useState(false)
  const [selected, setSelected] = useState<IOption>({
    label: '',
    value: ''
  })


  useEffect(() => {
    //revist this
    if (props.defaultInputValue) {
      if (props.curried) {
        setInputValue(props.defaultInputValue)
        props.handleInputChange()(props.defaultInputValue)
      } else {
        setInputValue(props.defaultInputValue)
        props.handleInputChange()(props.defaultInputValue)
      }
    }
  }, [props.defaultInputValue])

  useEffect(() => {
    if (props.defaultDropDownValue && props.options) {
      const defaultDropDownValue = props.options.find(option => option.value === props.defaultDropDownValue)
      if (props.curried) {
        props.handleDropDownChange()(props.defaultDropDownValue)
      } else {
        props.handleDropDownChange(props.defaultDropDownValue)
      }
      setSelected(defaultDropDownValue)
    }
  }, [props.defaultDropDownValue, props.options])

  useEffect(() => {
    if (props.clearInputValue) {
      setInputValue('1')
      props.handleInputChange()('')
      setSelected(props.options[0])
    }
  }, [props.clearInputValue])

  const { Option } = components;
  const IconOption = (props: any) => (
    <Option {...props} className='tw-flex'>
      {props.data.label}
      {props.isSelected && <svg className='tw-w-5 tw-h-5 tw-ml-auto' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#2bab66">
        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
      </svg>}
    </Option>
  )

  const handleInputChange = (value: string) => {
    setInputValue(value)
    props.handleInputChange()(value)
  }

  const handleDropDownChange = (option: any) => {
    setSelected(option)
    if (props.curried) {
      props.handleDropDownChange()(option.value)
    } else {
      props.handleDropDownChange(option.value)
    }
  }

  const selectStyles = {
    control: (base: any) => ({
      ...base,
      "&:hover": {
        borderColor: "red"
      }
    }),
    menuList: (base: any) => {
      return {
        ...base,
        '&': {
          padding: '0',
          overflow: 'hidden',
          boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.02), 0 4px 7px 0 rgba(0, 0, 0, 0.03), 0 9px 14px 0 rgba(0, 0, 0, 0.04), 0 18px 29px 0 rgba(0, 0, 0, 0.05), 0 48px 80px 0 rgba(0, 0, 0, 0.07)',
          borderRadius: '6px'
        }
      }
    },
    indicatorsContainer: (base: any, state: any) => {
      return {
        ...base,
        '&': {
          borderLeft: '1px solid #e2e2e2;'
        },
      }
    },
    singleValue: (base: any, state: any) => {
      return {
        ...base,
        '&': {
          fontSize: '14px'
        },
      }
    },
    placeholder: (base: any, state: any) => {
      return {
        ...base,
        '&': {
          fontSize: '14px'
        },
      }
    },
    option: (base: any, state: any) => {
      return {
        ...base,
        '&': {
          padding: '12px 16px',
          fontSize: '14px',
          fontWeight: state.isSelected ? '500' : '400',
          background: state.isSelected ? '#f9f9fb' : '#fff',
          color: '#2d2c2b',
          borderBottom: '1px solid #e2e2e2'
        },
        '&:last-child': {
          background: 'none'
        },
        '&:hover': {
          fontWeight: '500',
          background: '#f9f9fb'
        }
      }
    }
  };


  return (
    <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`}>
      {props.label && <span className={styles.inputLabel}>{props.label}</span>}
      <div className={`${styles.inputWrapper} ${focused ? styles.focused : ''}`}>
        <input
          id={props.name}
          className={styles.input}
          placeholder={props.placeholder}
          type='text'
          readOnly={props.readOnly}
          disabled={props.readOnly}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          value={inputValue}
          onChange={(e) => handleInputChange(e.target.value)}
        />
        <Select
          placeholder={props.placeholder}
          options={props.options}
          styles={selectStyles}
          isDisabled={props.readOnly}
          isSearchable={!props.readOnly}
          className={styles.dropDown}
          classNamePrefix="react-select"
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          value={selected}
          components={{ Option: IconOption, IndicatorSeparator: () => null }}
          onChange={(e) => handleDropDownChange(e)}
        />
      </div>
    </div>
  )
})

export default DropDownInput
